import React from "react";
import {FilterDropdownProps} from "antd/lib/table/interface";
import FilterContainer from "./FilterContainer";
import ContractorMultiSelect from "../../select/MultiSelect/ContractorMultiSelect";
import {LabeledValue} from "antd/lib/select";
import {DELAY_TIMER_SEARCH_FILTER, endAndStartTimerFilter} from "./columnsUtils";

export default function ContractorFilter(props: FilterDropdownProps) {

    return <FilterContainer {...props}>
        <ContractorMultiSelect
            style={{width: '20rem'}}
            onChange={(values: LabeledValue[]) => {
                // @ts-ignore
                props.setSelectedKeys(values.reverse().map(el => ({label: el.label, value: el.value})))
                endAndStartTimerFilter(props.confirm, DELAY_TIMER_SEARCH_FILTER)
            }}
            value={props.selectedKeys}
        />
    </FilterContainer>
}